import { ExtendedDropdown } from './ExtendedDropdown';
import { ExtendedDropdownSection } from './ExtendedDropdownSection';
import { ExtendedDropdownLink } from './ExtendedDropdownLink';

ExtendedDropdown.Section = ExtendedDropdownSection;
ExtendedDropdown.Link = ExtendedDropdownLink;

export default ExtendedDropdown;